import React, { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import Resizer from "react-image-file-resizer";
import { confirmAlert } from "react-confirm-alert";

export default function MyEditor(props) {
  const editorRef = useRef(null);
  const { height, initialValue, onValue } = props;
  const [value, setValue] = useState(initialValue);
  const { user } = useSelector((state) => state.auth);
  //const [file, setFile] = useState(null)

  const inputRef = useRef(null);
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        600, //width
        600, //height
        "JPEG", 90, 0,
        (uri) => resolve(uri),
        "file"
      );
    });
  const uploadAudio = (event) => {

    const fileAudio = event.target.files[0]
    if (fileAudio) {
      let data = new FormData()
      data.append("type", "s3")
      data.append("name", "file")
      data.append("file", fileAudio)
      data.append("filetype", fileAudio.type)
      let file_size = fileAudio.size;
      if (file_size > 3145728) {
        confirmAlert({
          title: 'Lỗi',
          message: "File không được lớn hơn 3 Mb",
          buttons: [{ label: 'OK' }]
        })
        return
      } else {
        axios.post(URL_LIST_ALL + "upload", data, user.config).then(async (res) => {
          if (res.data.status === "success") {
            const url = res.data.url
            if(url){
              let oldValue = value.slice()
              let htmlAudio = '<audio controls src="'+url+'"> Your browser does not support them <code>audio</code> element.</audio>'
              setValue(oldValue + htmlAudio)
            }
            
            // setFile(res.data.url);
          } else {
            return;
          }
        }).catch((err) => { console.log(err) })
      }

    }
  }
  return (<>
    <input type="file" id="file" ref={inputRef} style={{ display: "none" }} accept="audio/*" onChange={uploadAudio} />
    <Editor
      apiKey="clzolpoaxrhjthzj5smwqabv4fmcm108jos1avpayw07e70l"
      onInit={(evt, editor) => (editorRef.current = editor)}
      value={value}
      onFocusOut={() => {
        const valuecontent = editorRef.current.getContent()
        if (valuecontent && valuecontent !== initialValue) {
          onValue(editorRef.current.getContent())
        }
      }}
      onEditorChange={(newValue, editor) => {
        setValue(newValue);
      }}

      init={{
        height: height,
        menubar: false,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor media ",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
        ],
        toolbar:
          "undo redo | styleselect |" +
          "bold italic underline backcolor |" +
          "alignleft aligncenter alignright alignjustify |" +
          "bullist numlist outdent indent removeformat |" +
          "image media help",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        images_upload_handler: async function (
          blobInfo: any,
          success: any,
          failure: any
        ) {
          let filesize = 0;
          let data = new FormData()
          data.append("type", "s3")
          data.append("name", "file")
          data.append("file", blobInfo.blob())
          data.append("filetype", blobInfo.blob().type)
          // console.log(imageFile);
          try {
            resizeFile(blobInfo.blob())
              .then((image) => {
                if (filesize > 3145728) {
                  confirmAlert({
                    title: 'Lỗi',
                    message: "File không được lớn hơn 3 Mb",
                    buttons: [{ label: 'OK' }]
                  })
                  return
                }
                axios.post(URL_LIST_ALL + "upload", data, user.config)
                  .then(async (res) => {
                    if (res.data.status === "success") {
                      success(res.data.url);
                    } else {
                      return;
                    }
                  })
                  .catch((err) => {
                    console.log(err)
                  })
              })
            //success(data.fileURL);
          } catch (error) {
            console.log(error);
            return;
          }

        }
      }
      }
    />
  </>
  );
}
